import VenoBox from 'venobox';
import 'venobox/dist/venobox.min.css';

document.addEventListener('DOMContentLoaded', () => {
    new VenoBox({
        selector: '.lightbox',
    });
});
